module.exports = __webpack_public_path__ + "static/media/lishijil.8106993b.png";